<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
        <div class="card-title">
            <h5 style="text-align: start">{{ title }}</h5>
        </div>
        <div class="card-toolbar">    
          <ButtonDropdownFilter
              :key="creator"
              :btn-title="$t('crm.label.owner')"     
              :options="users"
              value-field="id"
              name-field="fullname"
              v-model="query.creator_id" 
              :border="true" 
          />
        </div> 
        </div>
        <Loader :is-loading="loading">
          <div class="card-body">
            <div v-show="!topTotalAppointmentsPerCreator?.length" class="text-center"> 
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-show="topTotalAppointmentsPerCreator?.length" class="p-5 positive-relative">
              <canvas id="kt_chartjs_sellerss" class="mh-200px"></canvas>
              <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; height: 50%; top: 55%; left: 50%; transform: translate(-50%, -50%);">
                  <div class="text-center">
                    <h1 class="display-5">{{totalAppointmentsPerCreator[0]?.total}}</h1>
                    <span>{{ $t('menu.crm.appointments') }}</span>
                  </div>
                </div>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import ButtonDropdownFilter from '@/components/ButtonDropdownFilter.vue';
import Loader from '@/components/Loader.vue';
import { useLocales } from '@/composables/locales';
import { computed,  onMounted, ref, watch} from 'vue';
import { useStore } from 'vuex';

const store = useStore()
const {locale} = useLocales()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function} ,
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    creator_id: ''
})

const creator = ref(0)

const topTotalAppointmentsPerCreator = ref([])
const chartAppointmentSellerRef = ref(null)
const totalAppointmentsPerCreator = ref(0)

const users = computed(() => store.getters["user/getUsers"])
const appointmentStatus = computed(() => store.getters['appointments/appointmentStatus'])

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, creator_id: query.value.creator_id}).then((res) => {
          let answer = res.response?.data || res?.data?.topTotalAppointmentsPerCreator
          
          totalAppointmentsPerCreator.value =  Object.values(answer).filter(item => item.name == 'global_total')
          topTotalAppointmentsPerCreator.value = Object.values(answer).filter(item => item.name !== 'global_total');

        }),
        store.dispatch('user/loadUsers'),
        store.dispatch('appointments/loadAppointmentStatus'),

    ]).then(() => {
      creator.value += 1
      chartAppointmentSeller()
    })
}

function chartAppointmentSeller(){
    let names = [];
    let counts = [];
    let colors = [];
  
    topTotalAppointmentsPerCreator.value?.forEach(item => {
      let filter = filterStatus(item.name)
     
      if(item.total > 0 && filter) { 
        names.push(filter[locale.value])
        counts.push(item.total)
        colors.push(getColor(item.name))
      }
    })
  
    if(names.length === 0 || counts.length === 0){
      topTotalAppointmentsPerCreator.value = [];
    }
  
    let ctx = document.getElementById('kt_chartjs_sellerss');
  
    if (ctx) {
      if(Chart.getChart("kt_chartjs_sellerss")) {
        Chart.getChart("kt_chartjs_sellerss")?.destroy()
      }

      let context = ctx.getContext('2d');
      let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');
  
      let data = {
          labels: names,
          datasets: [{
            data: counts,
            backgroundColor: colors,
            hoverOffset: 10
        }]
      };
  
      let config = {
          type: 'doughnut',
          data: data,
          options: {
            plugins: {
                legend: {
                    display: true,
                    position: 'bottom'
                },
                tooltip: {
                    callbacks: {
                        label: function(context) {
                          let countLabel = i18n.global.t('appointments.count');
                            return `${countLabel}: ${$formatLocalAmount(context.parsed)}`;
                        }
                    }
                }
            },
            responsive: true,
            elements: {
              arc: {
                  borderWidth: 1 
              }
            },
            cutout: '40%'
          },
          defaults:{
              global: {
                  defaultFont: fontFamily
              }
          }
      };
  
      if (!chartAppointmentSellerRef.value) {
        chartAppointmentSellerRef.value = new Chart(ctx, config);
      }else{
        chartAppointmentSellerRef.value.destroy()
        chartAppointmentSellerRef.value = new Chart(ctx, config);
      }
    } else {
      console.error('Canvas element not found');
      return;
    }
  }

  function getColor(value){
    let color = ''
    switch (value) {
      case 'COMPLETED':
        color = '#2DA333';
        break;
      case 'CANCELLED':
        color = '#E51335';
        break;
      case 'REPORTED':
        color = '#0072CE';
        break;
      case 'SCHEDULED':
        color = '#E51335';
        break;
      default:
        color = '#000000';
    }
  
    return color;
  }

  function filterStatus(value) {
    let statistic = appointmentStatus.value.find(status => status.value === value);
    return statistic;
  }

onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end

    
})
</script>